import * as React from 'react';
import { AppBar } from '@mui/material';
import TextToolbar from './TextToolbar';

const ToolHeader = () => {
  return (
    <React.Fragment>
      {/* Header */}
      <AppBar
        position="fixed"
        className="tool-header"
        sx={{
          boxShadow: 'none',
          backgroundColor: '#101a30',
          borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        }}
        role="banner"
        aria-label="Application Header"
      >
        <TextToolbar />
      </AppBar>
    </React.Fragment>
  );
};

export default ToolHeader;
